const extractName = (filename: string): string | undefined =>
  /\.\/([a-zA-Z0-9\-_]+)\.svg$/.exec(filename)?.[1] ?? undefined;

// 필요가 생기면 위로...
export const importAll = (r: any, cache: Record<string, string>): void => {
  r.keys().forEach((key: string) => {
    const name = extractName(key);
    if (!name) {
      return;
    }
    cache[name] = r(key);
  });
};
